export const formatYearMonthDay = "YYYY-MM-DD";

export const formatDayMonthYear = "DD-MM-YYYY";

export const formatDayMonthYearSlash = "DD/MM/YYYY";
